module.exports = __webpack_public_path__ + "img/dex_l1.eabc437f.svg";